var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c(
            "el-radio-group",
            {
              model: {
                value: _vm.currentValue,
                callback: function($$v) {
                  _vm.currentValue = $$v
                },
                expression: "currentValue"
              }
            },
            _vm._l(_vm.prop.allowedValues, function(item, index) {
              return _c(
                "el-radio",
                { key: index, attrs: { label: parseInt(item.id) } },
                [_vm._v("\n            " + _vm._s(item.name) + "\n        ")]
              )
            }),
            1
          )
        : _c("p", [
            _vm._v("\n        " + _vm._s(_vm.localValueLabel) + "\n    ")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }